import { render, staticRenderFns } from "./Timestamp.vue?vue&type=template&id=da9571d4&scoped=true"
import script from "./Timestamp.vue?vue&type=script&lang=js"
export * from "./Timestamp.vue?vue&type=script&lang=js"
import style0 from "./Timestamp.vue?vue&type=style&index=0&id=da9571d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da9571d4",
  null
  
)

export default component.exports